import { takeEvery, takeLatest } from 'redux-saga/effects';
import { VIOLATIONS_MODULE } from '../../../configs/moduleNames';
import {
  EXPORT_WORK_CONTROL,
  LOAD_CONTROL_WORK_VIOLATIONS_BY_ID,
  LOAD_CONTROL_WORK_VIOLATIONS_LIST,
  LOAD_VIOLATIONS_BY_ID,
  LOAD_VIOLATIONS_LIST,
} from '../actions';
import loadViolationList from './loadViolationList';
import loadViolationById from './loadViolationById';
import loadViolationControlWorkById from './loadViolationControlWorkById';
import loadViolationControlWorkList from './loadViolationControlWorkList';
import exportWorkControl from './exportWorkControl';

export default function* watchClient() {
  yield takeLatest(VIOLATIONS_MODULE + LOAD_VIOLATIONS_LIST, loadViolationList);
  yield takeLatest(VIOLATIONS_MODULE + LOAD_CONTROL_WORK_VIOLATIONS_LIST, loadViolationControlWorkList);
  yield takeEvery(VIOLATIONS_MODULE + LOAD_VIOLATIONS_BY_ID, loadViolationById);
  yield takeEvery(VIOLATIONS_MODULE + LOAD_CONTROL_WORK_VIOLATIONS_BY_ID, loadViolationControlWorkById);
  yield takeEvery(VIOLATIONS_MODULE + EXPORT_WORK_CONTROL, exportWorkControl);
}
